import { createStyles, makeStyles } from '@mui/styles';

const useSnapshotPreviewStyles = makeStyles(({ palette }) => {
  return createStyles({
    cardWrapper: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      height: '100%',
      color: palette.common.white,
    },
  });
});

export default useSnapshotPreviewStyles;
